import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { toast } from 'components/global/CUK/Toast/Toast'
import ActionModal from 'components/Modal/ActionModal'

import { useDetail } from '../use-event-ssids'
import { useRemove } from '../use-actions'
import { trackEvent } from 'analytics'

const ActionRemove = () => {
  const { t } = useTranslation()
  const { item } = useDetail()
  const navigate = useNavigate()
  const [remove, { loading }] = useRemove()
  const handleClose = () => navigate('..')

  const handleRemove = async () => {
    const { error } = await remove()
    if (error) {
      toast.error(t('event_ssids.modal.remove.error'))
    } else {
      toast.success(t('event_ssids.modal.remove.success'))
      trackEvent('wifi_management_deleted')
    }
    navigate('../..')
  }

  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmLabel={t('ui_elements.remove')}
      description={t('event_ssids.modal.remove.description', { name: item?.name })}
      icon={<i className="fa-regular fa-trash" />}
      loading={loading}
      onClose={handleClose}
      onConfirm={handleRemove}
      title={t('event_ssids.modal.remove.title')}
    />
  )
}

export default ActionRemove